export const MULTIPAGE_PREVIEW_THUMBNAIL_SELECTION_PANEL_ID = 'multipage-preview-thumbnail-selection-panel';

export interface MultipagePreviewThumbnailSelectionPanelProps {
  posterHashedId: string;
  onClose?(): void;
  onSubmit?(): void;
}
